/* tslint:disable */
/* eslint-disable */
export enum NotificationSendingState {
  Pending = 1,
  Successful = 2,
  Failed = 3
}